
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit, Input, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { trigger, transition, style, animate } from '@angular/animations';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserData } from '@riise/shared/utils/constants/users';
import { AnnouncementsService } from '@riise/core/services/announcements/announcements.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-announcement',
    imports: [TranslateModule, RouterModule, ReactiveFormsModule, FormsModule, NgSelectModule, NgScrollbarModule, NgbModule],
    templateUrl: './announcement.component.html',
    styleUrls: ['./announcement.component.scss'],
    animations: [
        trigger('fadeIn', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('300ms ease-out', style({ opacity: 1 }))
            ]),
            transition(':leave', [
                animate('300ms ease-in', style({ opacity: 0 }))
            ])
        ])
    ]
})
export class AnnouncementComponent implements OnInit {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private userData = inject(UserData);
  private translateService = inject(TranslateService);
  private announcementsService = inject(AnnouncementsService);
  private dialogRef = inject<MatDialogRef<AnnouncementComponent>>(MatDialogRef);
  reference = inject(MAT_DIALOG_DATA);

  showOnboarding: boolean = true;
  currentSlide = 0;
  slides: any;
  isLoading: boolean = true;

  /** Inserted by Angular inject() migration for backwards compatibility */


  constructor() { }

  ngOnInit(): void {
    if (this.reference) {
      this.isLoading = true;
      this.announcementsService?.getAnnouncementId(this.reference).subscribe({
        next: (result: any) => {
          let imageUrl = JSON.parse(result?.data?.spaceAnnounce?.edges[0]?.node?.publishedAnnounce?.announce?.imageUrl);
          this.slides = Object.values(imageUrl);
          this.isLoading = false;
        },
        error: () => {
          this.isLoading = false;
        }
      });
    } else {
      this.isLoading = false;
    }
  }

  nextSlide(): void {
    if (this.currentSlide < this.slides?.length - 1) {
      this.currentSlide++;
    }
  }

  previousSlide(): void {
    if (this.currentSlide > 0) {
      this.currentSlide--;
    }
  }

  goToSlide(index: number): void {
    this.currentSlide = index;
  }

  finishOnboarding(): void {
    this.showOnboarding = false;
  }
}
